import { useMemo } from 'react';
import { IOverflowFilterChipItem } from 'src/components/overflowFilterChips';

interface IUseLocationFilterPills {
  activeFilters: Record<string, string[] | string>;
  locationOwnerTagNameMap: Record<string, string>;
  onChangeFilter: (filterKey: string, value: string[]) => void;
}

export const useLocationFilterPills = ({
  activeFilters,
  locationOwnerTagNameMap,
  onChangeFilter,
}: IUseLocationFilterPills) =>
  useMemo(
    () =>
      Object.entries(activeFilters)
        .flatMap(([filterKey, filterValues]) => {
          const values = Array.isArray(filterValues)
            ? filterValues
            : [filterValues];

          return values.map((value, index): IOverflowFilterChipItem | null => {
            if (
              filterKey === 'location_owner_tag_id' &&
              !locationOwnerTagNameMap[String(value)]
            ) {
              return null;
            }

            return {
              key: `filter-${filterKey}-${index}`,
              label:
                filterKey === 'location_owner_tag_id'
                  ? locationOwnerTagNameMap[String(value)]
                  : String(value),
              onRemove: () => {
                const updatedValues = values.filter((_, i) => i !== index);
                onChangeFilter(filterKey, updatedValues);
              },
            };
          });
        })
        .filter((item): item is IOverflowFilterChipItem => item !== null),
    [activeFilters, locationOwnerTagNameMap, onChangeFilter],
  );
